import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

interface Props {
  children: React.ReactNode;
}

const ModalPortal = ({ children }: Props) => {
  const element = useRef<HTMLDivElement>(undefined);

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    element.current = document.querySelector('.modal-root');
    setMounted(true);
  }, []);

  return mounted ? ReactDOM.createPortal(children, element.current) : null;
};

export default ModalPortal;
